import Leading from 'pages/inedx'
import './static/global.css'
import 'utils/i18n'

function App() {
  return <Leading />
}

export default App
